import useSWR from "swr";
import { reqGetHeadersFront } from "grandus-lib/utils";

import Gallery from "components/gallery/Gallery";
import ProductLabels from "components/product/card/ProductLabels";

import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import forEach from "lodash/forEach";
import join from "lodash/join";
import flatten from "lodash/flatten";

const PackageGallery = ({ product }) => {
    let productIds = [];

    forEach(get(product, 'productPackageProducts', []), (packageProduct) => {
        if (get(packageProduct, 'product.id')) {
            productIds.push(`productIds=${get(packageProduct, 'product.id')}`);
        }
    });

    const { data: productsResponse, error } = useSWR(
        `/api/lib/v1/products?${join(productIds, '&')}`,
        (url) =>
            fetch(url, {
                headers: reqGetHeadersFront(null),
            }).then((r) => r.json()),
        {
            revalidateOnMount: true,
        }
    );

    let galleries = [];

    if(!isEmpty(get(product, 'gallery'))){
        galleries.push(get(product, 'gallery'));
    }

    forEach(get(productsResponse, "products"), (prod) => {
        if(!isEmpty(get(prod, "gallery", []))){
            galleries.push(get(prod, "gallery", []));
        }
    });

    return (
        <Gallery
            titleImage={get(product, "photo", null)}
            images={flatten(galleries)}
            showThumbnails
            options={{
                imageMainProps: {
                    size: "442__cropped",
                },
                imageThumbnailProps: {
                    size: "106__cropped",
                },
            }}
            >
            <ProductLabels
                {...{
                    new: product?.new,
                    status: product?.status,
                    favourite: product?.favourite,
                    labels: product?.labels,
                }}
            />
        </Gallery>
    );
};

export default PackageGallery;


